import { Injectable } from "@angular/core";
import { ApicallService } from "@core-services/apicall.service";
import {
	Device,
	DeviceAdapter,
	DeviceApiModel
} from "@modules/+new/core/device-redirection-guard/entities/device.model";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { BasicApiObject, parseApiResponseObject } from "@helpers/functions";

@Injectable({
	providedIn: "root"
})
export class TransactionDeviceRemote {
	constructor(private readonly apiCallService: ApicallService) {}

	public getUsedDevice$(transactionId: string): Observable<Device> {
		return this.apiCallService.get(`fiatwallet/transactions/${transactionId}/devices`).pipe(
			map((response: BasicApiObject) => parseApiResponseObject<DeviceApiModel>(response)),
			map((response: DeviceApiModel) => DeviceAdapter.adapt(response))
		);
	}
}
